import Vue from 'vue'
import { TypeOffre } from '@/enum/TypeOffre'

Vue.filter('typeOffre', function(value: TypeOffre ) {
  if (value) {
    switch(value){
      case TypeOffre.PrincipalStored:
        return 'Flux des offres stockées (donc neuves et principales comme STK en v2)'
      case TypeOffre.PrincipalMkpNeuf:
        return 'Flux des offres MKP principales neuves uniquement'
      case TypeOffre.PrincipalMkpOcca:
        return  'Flux des offres MKP principales occasion uniquement'
      case TypeOffre.PrincipalMkpReco:
        return  'Flux des offres MKP principales reconditionnées uniquement'
      case TypeOffre.ExtendMkpNew:
        return  'Flux des offres complémentaires MKP neuves (MKP-1)'
      case TypeOffre.ExtendMkpOcca:
        return  'Flux des offres complémentaires MKP occasion (MKP-2)'
      case TypeOffre.ExtendMkpReco:
        return  'Flux des offres complémentaires MKP reconditionnées (MKP-3)'
      case TypeOffre.CmbPrincipalAll:
        return  'Toutes les offres principales (comme STK + MKP en v2)'
      case TypeOffre.CmbPrincipalMkp:
        return  'Toutes les offres principales MKP (comme MKP en v2)'
      case TypeOffre.CmbOverall:
        return  'Tous'
      case TypeOffre.CmbPrincipalNeuf:
        return  'Toutes les offres principales neuves donc soit STK soit MKP principales'
      case TypeOffre.CmbFullMkpNeuf:
        return  'Toutes les offres MKP neuves (principales et secondaires)'
      case TypeOffre.CmbFullMkpOcca:
        return  'Toutes les offres MKP occasion (principales et secondaires)'
      case TypeOffre.CmbFullMkpReco:
        return  'Toutes les offres MKP reconditionnées (principales et secondaires)'      
    }        
    return ''
  }
})